import { defineComponent as S, computed as f, useSlots as b, openBlock as g, createElementBlock as m, normalizeStyle as y, unref as v, Fragment as A, createTextVNode as k, toDisplayString as x, createCommentVNode as p, renderSlot as z } from "vue";
const C = ["src", "alt"], V = /* @__PURE__ */ S({
  __name: "VueAvatar",
  props: {
    username: { default: "Vue Avatar" },
    size: { default: 50 },
    borderRadius: { default: "100%" },
    backgroundColor: null,
    color: null,
    lighten: { default: 150 },
    imgSrc: null,
    imgAlt: null
  },
  setup(l) {
    const e = l, c = f(() => {
      var t;
      return (t = e.username.match(/[A-ZА-ЯЁ]/g)) == null ? void 0 : t.slice(0, 3).join("");
    }), i = f(() => ({
      width: `${e.size}px`,
      height: `${e.size}px`,
      borderRadius: e.borderRadius,
      fontSize: `${e.size / 2.2}px`,
      backgroundColor: _.value,
      color: e.color || d(_.value, e.lighten)
    })), d = (t, o) => {
      let r = !1;
      t[0] === "#" && (t = t.slice(1), r = !0);
      const n = parseInt(t, 16);
      let s = (n >> 16) + o;
      s > 255 ? s = 255 : s < 0 && (s = 0);
      let a = (n >> 8 & 255) + o;
      a > 255 ? a = 255 : a < 0 && (a = 0);
      let u = (n & 255) + o;
      return u > 255 ? u = 255 : u < 0 && (u = 0), (r ? "#" : "") + (u | a << 8 | s << 16).toString(16);
    }, _ = f(() => {
      if (e.backgroundColor)
        return e.backgroundColor;
      let t = 0;
      for (let r = 0; r < e.username.length; r++)
        t = e.username.charCodeAt(r) + ((t << 5) - t);
      let o = "#";
      for (let r = 0; r < 3; r++) {
        const n = t >> r * 8 & 255;
        o += ("00" + n.toString(16)).substr(-2);
      }
      return o;
    }), h = b();
    return (t, o) => (g(), m("div", {
      style: y(v(i)),
      class: "vue-avatar"
    }, [
      !v(h).default && !e.imgSrc ? (g(), m(A, { key: 0 }, [
        k(x(v(c)), 1)
      ], 64)) : p("", !0),
      l.imgSrc && l.imgSrc.length ? (g(), m("img", {
        key: 1,
        src: e.imgSrc,
        alt: l.imgAlt
      }, null, 8, C)) : p("", !0),
      z(t.$slots, "default", {}, void 0, !0)
    ], 4));
  }
});
const $ = (l, e) => {
  const c = l.__vccOpts || l;
  for (const [i, d] of e)
    c[i] = d;
  return c;
}, R = /* @__PURE__ */ $(V, [["__scopeId", "data-v-ae9e4b12"]]);
export {
  R as default
};
